import type { UrlRootPath } from '@ms/yammer-libs-url-path-support';
import { trimBasenameAndNetworkFromUrlPath, trimLeadingSlash, urlRootPaths } from '@ms/yammer-libs-url-path-support';

type GetFirstResource = (urlPath: string) => string | null;
const ignorePaths: UrlRootPath[] = [
  'org',
  'network',
  'admin',
  'user-settings',
  'inbox',
  'personalized-inbox',
  'logout',
  'authredirect',
  'insights',
  'leaders',
  'discover-groups',
  'ama',
  'broadcasts',
  'dashboard',
  'communications-plans',
];
const paths = urlRootPaths.filter((path) => !ignorePaths.includes(path));

export const getFirstResource: GetFirstResource = (urlPath) => {
  const urlPathWithoutBasename = trimBasenameAndNetworkFromUrlPath(urlPath);
  const trimmedUrlPath = trimLeadingSlash(urlPathWithoutBasename);
  const splitPath = trimmedUrlPath.split('/');
  const resourceIndex = splitPath.findIndex((path) => paths.includes(path as UrlRootPath));

  if (resourceIndex > -1 && resourceIndex < splitPath.length - 1) {
    return splitPath[resourceIndex + 1];
  }

  return null;
};
